import React from 'react'
import { HorizontalStack, Progress } from '@ztechapps/webui.util'
import { WorkOrderStatusBadge } from './index'
import type { WorkOrderStatusEnum } from '@ztechapps/common.contract'

export type WorkOrderStatusWithProgressProps = {
  status: WorkOrderStatusEnum
  progressNow: number
  progressMax: number
}
export const WorkOrderStatusWithProgress = ({ status, progressNow, progressMax }: WorkOrderStatusWithProgressProps) => {
  return (
    <HorizontalStack gap={1}>
      <div>
        <WorkOrderStatusBadge status={status} />
      </div>
      <div className="w-100">
        <Progress now={progressNow} max={progressMax} />
      </div>
    </HorizontalStack>
  )
}
